import { z } from 'zod'

export const schema = z.object({
  modules: z.array(
    z.object({
      title: z.string(),
      url: z.string().nullable(),
      seoEntities: z.array(
        z.object({
          name: z.string(),
          url: z.string(),
        }),
      ),
    }),
  ),
})

export type schemaType = z.infer<typeof schema>

export const paramsSchema = z.object({
  facetSlug: z.string(),
  searchListType: z.enum(['list', 'facet', 'results']),
  page: z.number(),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
